import { Component, Input } from '@angular/core';
import { Status } from 'src/app/@core/enums/status.enum';

@Component({
  selector: 'app-custom-progress',
  templateUrl: './custom-progress.component.html',
  styleUrls: ['./custom-progress.component.scss']
})
export class CustomProgressComponent {
  @Input() value: number = 0;
  @Input() status: Status | null = null;

  /**
   * Get progress bar color class based on course status
   * Gray: NotComplete, Pending
   * Blue: InActive, Draft
   * Green: Completed
   */
  get progressColorClass(): string {
    if (!this.status && this.status !== 0) return 'progress-default';
    
    switch (this.status) {
      case Status.Completed:
        return 'progress-completed';
      case Status.InActive:
      case Status.Draft:
        return 'progress-inactive';
      case Status.NotComplete:
      case Status.Pending:
      case Status.Archived:
      case Status.Rejected:
      case Status.Deleted:
      default:
        return 'progress-incomplete';
    }
  }
}
